export default __webpack_public_path__ + "static/media/doc01.413f31b3.svg";